/* eslint-disable jira/filename-case */
export const CONSOLIDATION_STATE_RESOURCE_TYPE = 'EOC_TENANT';
